/** @jsxImportSource solid-js */
import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
} from "libphonenumber-js";
import { createEffect, type JSX } from "solid-js";
import { classes } from "../../style/index.solid";
import { createTextInput } from "./text.solid";

export function createPhoneInput({
  initial = "",
  placeholder = "Enter your phone number",
  label = "Phone",
  tooltip = null as JSX.Element,
}) {
  const baseInput = createTextInput({
    label,
    initial,
    placeholder,
    tooltip,
  });
  const valid = () => {
    return (
      baseInput.value() === "" || isValidPhoneNumber(baseInput.value(), "US")
    );
  };
  const countryCode = () => {
    try {
      return parsePhoneNumberWithError(baseInput.value(), "US").country;
    } catch (_e) {
      return null;
    }
  };
  createEffect(() => {
    if (countryCode()) {
      baseInput.setIcon(
        <div class={classes("flag", `flag:${countryCode()}`)}></div>,
      );
    }
  });

  return {
    // TODO: make this auto-format the number to the correct form
    component: (
      <>
        {baseInput.component}
        {!valid() && (
          <strong class="text-status-error-fg p-2">
            Please enter a valid phone number.
          </strong>
        )}
      </>
    ),
    value: baseInput.value,
    isValid: valid,
  };
}
